<template>
  <div class="card">
    <!---div class="card-top">免费</div--->
    <div class="card-content">
      <img :src="appData.logo">
      <span>{{ appData.name }}</span>
    </div>
    <div class="card-bottom">
      {{ appData.desc }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChatApplicaton',
  components: {},
  props: {
    appData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      iconUrl: require('@/assets/images/laoshibang/chat-icon.png')
    };
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.card {
    width: 260px;
    height: 120px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #FFF;
    padding: 0 0 0 20px;
    position: relative;
    &-top {
        width: 60px;
        height: 25px;
        float: right;
        flex-shrink: 0;
        border-radius: 0px 10px;
        background: #E2EBFF;
        color: #0D70ED;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 25px;
        text-align: center;
    }
    &-content {
        display: flex;
        align-items: center;
        position: absolute;
        top: 24px;
        img {
            width: 32px;
            height: 32px;
            flex-shrink: 0;
        }
        span {
            color: #323233;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin-left: 8px;
        }
    }
    &-bottom {
        width: 200px;
        position: absolute;
        top: 66px;
        color: #717171;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
}
</style>
